import { Pagination, UncontrolledPopover } from 'reactstrap';
import styled from 'styled-components';

import { Modal } from 'shared/components/modal/Modals';
import { colors, fontSizes, fonts, device } from 'shared/defaultTheme';

export const TagsWrapper = styled.div`
  @media ${device.sm} {
    .w-search {
      width: 100%;
    }
    .action-header-mobile {
      flex-direction: column-reverse;
      .w-container-search-mobile {
        width: 100% !important;
        margin-top: 10px;
      }
    }
  }
  @media ${device.md} {
    .w-search {
      width: 100%;
    }
  }
  @media ${device.lg} {
    .w-search {
      width: 100%;
    }
  }

  @media ${device.xl} {
    .w-search {
      width: 100%;
    }
  }
  .btn-header-action {
    height: 41px;
    align-items: center;
  }
  .link-name-tag {
    cursor: pointer;
    &:hover {
      color: ${colors.suvaGrey};
    }
  }
`;

export const PaginationTable = styled(Pagination)`
  .page-item.active .page-link {
    z-index: 3;
    color: black;
    background-color: transparent;
    border-color: transparent;
    font-weight: bold;
  }
  .page-item.disabled .page-link {
    background-color: transparent;
    border-color: transparent;
  }
`;

export const TdActions = styled.td`
  text-align: end;
`;

export const TagFormModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }

    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

export const TagFormWrapper = styled.div`
  padding: 0 20px;
  padding-bottom: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
  .row-content {
    padding: 0;
    .col-sm-12 {
      padding: 0;
    }
  }
  .form-field {
    margin-top: 26px;
    .required-mark {
      color: ${colors.error};
    }
    .row {
      padding: 0;
      margin-right: 0;
      margin-left: 0;
    }
  }
  .row-border-bottom {
    border-bottom: 1px solid ${colors.spanishGray};
    padding-bottom: 10px !important;
    margin-bottom: 24px;
  }
  .button-icon {
    background-color: ${colors.transparent};
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: ${fontSizes.md}px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: auto;

    &:active {
      opacity: 0.5;
    }
  }
`;

export const OptionMenu = styled.div`
  width: 90px;
  cursor: pointer;
  height: 30px;
  padding: 5px;
  &:hover {
    background-color: ${colors.whiteSmoke};
  }
`;

export const CustomModalWrapper = styled(Modal)`
  top: 15%;
  &.translate-modal {
    top: 10%;
    max-width: 930px;
    .row {
      width: 100% !important;
    }
    .translate-icon {
      height: 26px;
      width: 26px;
    }
    select {
      border: none;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
      background-size: 15px;
      height: 24px;
      min-width: 159px;
    }
  }
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding-left: 30px;
    padding-right: 30px;
  }
  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    margin-bottom: 10px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
  }
`;

export const TranslateLabel = styled.span`
  color: ${({ color }) => color};
  font-family: ${fonts.default};
  font-size: ${fontSizes.sm}px;
  font-weight: bold;
  line-height: 16px;
`;

export const H3 = styled.h3`
  font-size: ${fontSizes.sm}px !important;
`;

export const Popover = styled(UncontrolledPopover)`
  .popover {
    width: auto;
    border: none;
    box-shadow: 0 0 4px 0 #d6d8d9;
    .popover-body {
      padding: 0;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
`;
